/**
 * Offset payload used by timestamped segment annotations.
 */
interface Offset {
  start_offset: number
  end_offset?: number
}

/**
 * Narrows unknown input to a valid offset object shape.
 */
function isOffset(value: unknown): value is Offset {
  if (typeof value !== "object" || value == null) {
    return false
  }
  const candidate = value as Record<string, unknown>
  if (typeof candidate.start_offset !== "number") {
    return false
  }
  if (
    candidate.end_offset != null &&
    typeof candidate.end_offset !== "number"
  ) {
    return false
  }
  return true
}

/**
 * Safely parses offset arrays from either raw arrays or JSON strings.
 * Returns an empty array when parsing fails or values are malformed.
 */
export function parseOffsets(raw: unknown): Offset[] {
  if (raw == null) {
    return []
  }

  let arr: unknown = raw
  if (typeof raw === "string") {
    try {
      arr = JSON.parse(raw)
    } catch {
      return []
    }
  }

  if (!Array.isArray(arr)) {
    return []
  }

  return arr.filter(isOffset)
}
